module.exports = __webpack_public_path__ + "e01810faea8b99e0ad48c7662482a2e7.png";